import React from "react"

import { getThemeColor } from "./utils"
import PillButton from "../../../elements/V2/Buttons/PillButton"
import TextButton from "../../../elements/V2/Buttons/TextButton"

import { Color } from "@constants/V2/color"

type ButtonCellProps = {
  buttonLabel: string
  buttonLink: string | YocoCom.YocoLink | undefined
  secondButtonLabel?: string
  secondButtonLink?: string
  columnData: string
  theme: "light" | "dark"
}

const ButtonCell = ({
  buttonLabel,
  buttonLink,
  secondButtonLabel,
  secondButtonLink,
  columnData,
  theme,
}: ButtonCellProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-16 sm:flex-row">
      <PillButton
        size="medium"
        style="solid"
        text={buttonLabel}
        color={Color.Blue}
        linkUrl={buttonLink}
        trackingEvent="TableButtonEvent"
        trackingEventKey="column"
        trackingEventValue={columnData}
        className={
          secondButtonLabel && secondButtonLink ? "sm:!w-8/12" : "sm:!w-10/12"
        }
      />
      {secondButtonLabel && secondButtonLink && (
        <TextButton
          text={secondButtonLabel}
          linkUrl={secondButtonLink}
          style="text"
          color={getThemeColor(theme)}
        />
      )}
    </div>
  )
}

export default ButtonCell
